import { ApolloClient } from '@apollo/client';
import { createQueryPreloader } from '@apollo/client/react';
import type { PreloadQueryFunction } from '@apollo/client/react';

let _apolloClient: ApolloClient | null = null;
let _preloadQuery: PreloadQueryFunction | null = null;

/**
 * Stores the Apollo Client instance at module level for use by route loaders.
 * Called once during app initialization (before router creation).
 *
 * Note: ApolloClient has no generic type parameter in AC4 — the TCacheShape
 * generic was removed in the Apollo Client 3 → 4 migration.
 */
export function setApolloClient(client: ApolloClient) {
  _apolloClient = client;
  _preloadQuery = createQueryPreloader(client);
}

/**
 * Returns the module-level Apollo Client instance.
 * Throws if called before setApolloClient() — ensures loaders fail fast
 * with a clear message rather than silently returning null.
 */
export function getApolloClient(): ApolloClient {
  if (!_apolloClient) {
    throw new Error('Apollo Client not initialized. Call setApolloClient() during app init.');
  }
  return _apolloClient;
}

/**
 * Returns the module-level query preloader function.
 * Used by route loaders to initiate data fetches that return reactive QueryRefs.
 * Throws if called before setApolloClient() — ensures loaders fail fast.
 */
export function getPreloadQuery(): PreloadQueryFunction {
  if (!_preloadQuery) {
    throw new Error('Query preloader not initialized. Call setApolloClient() during app init.');
  }
  return _preloadQuery;
}
